import * as React from 'react';
import ChatChard from '../../../molecules/ChatCard';
import {Container, Separator} from './styles';
import {theme} from '../../../../styles/darkTheme';

interface Props {
  chats: any[];
}

const ListChats: React.FC<Props> = ({chats}) => {
  return (
    <Container>
      {chats.map((item, i, array) => {
        if (i < array.length - 1) {
          return (
            <div key={item.id}>
              <ChatChard channel={item} key={item.id} />
              <Separator theme={theme} />
            </div>
          );
        }
        return <ChatChard channel={item} key={item.id} />;
      })}
    </Container>
  );
};

export default ListChats;
